import React from 'react';

const SpendTransparent = ({ className }: { className?: string }) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M19.016 1.28571C17.903 1.28571 17 3.97171 17 7.28571H19.016C19.988 7.28571 20.473 7.28571 20.774 6.95071C21.074 6.61471 21.022 6.17271 20.918 5.28971C20.64 2.95571 19.894 1.28571 19.016 1.28571Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 7.33971V17.9317C17 19.4427 17 20.1987 16.538 20.4967C15.783 20.9827 14.616 19.9627 14.029 19.5927C13.544 19.2867 13.302 19.1347 13.033 19.1257C12.742 19.1157 12.495 19.2627 11.971 19.5927L10.06 20.7977C9.544 21.1227 9.287 21.2857 9 21.2857C8.713 21.2857 8.455 21.1227 7.94 20.7977L6.03 19.5927C5.544 19.2867 5.302 19.1347 5.033 19.1257C4.742 19.1157 4.495 19.2627 3.971 19.5927C3.384 19.9627 2.217 20.9827 1.461 20.4967C1 20.1987 1 19.4437 1 17.9317V7.33971C1 4.48571 1 3.05971 1.879 2.17271C2.757 1.28571 4.172 1.28571 7 1.28571H19"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 7.28571C7.895 7.28571 7 7.95771 7 8.78571C7 9.61371 7.895 10.2857 9 10.2857C10.105 10.2857 11 10.9577 11 11.7857C11 12.6137 10.105 13.2857 9 13.2857M9 7.28571C9.87 7.28571 10.612 7.70271 10.886 8.28571M9 7.28571V6.28571M9 13.2857C8.13 13.2857 7.388 12.8687 7.114 12.2857M9 13.2857V14.2857"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SpendTransparent;
